import { useInitialOnce } from "../composables/useInitialOnce";

export default defineNuxtPlugin(async (nuxtApp: NuxtApp) => {
    console.log('[Locally]: Init.');

    const img: any = useImage();
    const {
        images,
        checksum,
        countries,
        currencies,
        cultures,
        country,
        layout,
        company
    }: any = useInitialOnce<any>('settings') ?? await useApi('/setting');

    return {
        provide: {
            locally: {
                getItem(key: string, factory?: Function) {
                    if (process.client) {
                        const json = localStorage.getItem(key);

                        if (json) {
                            return JSON.parse(json);
                        } else {
                            const obj = factory ? factory() : null;

                            if (obj) {
                                this.setItem(key, obj);
                            }

                            return obj;
                        }
                    } else {
                        const obj = factory ? factory() : null;

                        if (obj) {
                            this.setItem(key, obj);
                        }

                        return obj;
                    }
                },
                setItem(key: string, value: any) {
                    if (process.client) {
                        localStorage.setItem(key, JSON.stringify(value));
                        //if (typeof value === 'object') {
                        //    localStorage.setItem(key, JSON.stringify(value));
                        //} else {
                        //    localStorage.setItem(key, value)
                        //}
                    }
                },
                remove(key: string) {
                    localStorage.removeItem(key);
                },
                getSettings() {
                    let settings = this.getItem('pipeline.settings');

                    img.options.providers[images.provider].defaults.baseURL = images.baseURL; // Setting image provider base URL.

                    if (settings && settings.checksum !== checksum) {
                        settings = {
                            ...settings,
                            checksum: checksum,
                            countries: countries,
                            currencies: currencies,
                            cultures: cultures,
                            layout: layout,
                            company: company
                        }
                    } else if (!settings) {
                        settings = {
                            checksum: checksum,
                            countries: countries,
                            currencies: currencies,
                            language: nuxtApp.$i18n.locale.value,
                            country: country.id,
                            currency: country.currency,
                            cultures: cultures,
                            layout: layout,
                            company: company,
                            vat: true,
                        }
                    }

                    return settings;
                },
                filterKeys(key: string) {
                    return Object.keys(localStorage).filter((value) => value.startsWith(key));
                }
            },
            session: {
                getItem(key: string, factory?: Function) {
                    if (process.client) {
                        const json = sessionStorage.getItem(key);

                        if (json) {
                            return JSON.parse(json);
                        } else {
                            const obj = factory ? factory() : null;

                            if (obj) {
                                this.setItem(key, obj);
                            }

                            return obj;
                        }
                    } else {
                        const obj = factory ? factory() : null;

                        if (obj) {
                            this.setItem(key, obj);
                        }

                        return obj;
                    }
                },
                setItem(key: string, value: any) {
                    if (process.client) {
                        sessionStorage.setItem(key, JSON.stringify(value));
                    }
                },
                remove(key: string) {
                    if (process.client) {
                        sessionStorage.removeItem(key);
                    }
                },
                getSession() {
                    return this.getItem('pipeline.session', () => ({
                        payment: {}
                    }));
                }
            }
        }
    }
})